function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion, useCycle } from 'framer-motion';
/** @jsxRuntime classic */

/** @jsx jsx */

import { jsx, css, Global } from '@emotion/core';
import style from '../../styles/footer';
import * as TopBar from '../navigations/TopBar';
import * as SideMenuComponent from '../navigations/SideMenu';
import DropDownRol from '../forms/inputs/DropDownRol';
import * as ModalsComponent from './Modals';
import { LanguageSelectorNav, LanguageSelectorMobile } from '../LanguageSelector';
import { mediaQuery, isUIWebView, cloneElement } from '../../utils';
import useMediaQuery from '../../hooks/use-media-query';

var Logo = function Logo(props) {
  return jsx("svg", props, jsx("path", {
    d: "M159.998 33.749a2.24 2.24 0 0 1-2.23 2.251H3.23A2.24 2.24 0 0 1 1 33.75V3.25A2.24 2.24 0 0 1 3.23 1h154.538a2.24 2.24 0 0 1 2.23 2.25v30.499z",
    stroke: "#F7F7FF"
  }), jsx("path", {
    d: "M40.895 23.84c0 .11-.027.248-.136.332-1.21 1.106-3.216 2.017-5.606 2.017-3.738 0-7.255-2.377-7.255-7.325 0-4.67 3.188-7.242 7.034-7.242 4.066 0 6.401 2.682 6.401 6.247v1.353c0 .22-.164.388-.385.388h-10.14c.22 2.542 2.363 3.702 4.59 3.702 1.812 0 3.625-.745 4.533-2.073.055-.083.137-.083.248-.055l.577.22c.083.055.137.083.137.193v2.243h.002zm-2.17-6.137c0-2.156-1.595-3.316-3.848-3.316-2.527 0-3.82 1.463-4.094 3.316h7.941zM54.716 22.927c-.577 2.211-2.639 3.317-5.001 3.317-2.967 0-5.88-2.046-5.88-7.157 0-5.086 3.353-7.38 6.32-7.38 2.363 0 4.37 1.243 4.78 3.177h.249l.659-2.459c.11-.333.246-.443.577-.443h1.895a.41.41 0 0 1 .385.553l-1.621 5.306v2.6c.659 1.575.962 3.121.962 4.532 0 3.925-2.28 6.882-6.951 6.882-2.666 0-4.342-.663-6.046-1.659a.339.339 0 0 1-.192-.303l.055-3.039c0-.11.082-.22.192-.248l.686-.165c.082-.028.192.055.249.11.962 1.824 2.857 2.57 4.835 2.514 2.611-.027 4.37-1.603 4.37-4.255 0-.498-.055-1.023-.274-1.879h-.249v-.004zm.027-3.95c0-2.487-1.566-4.396-4.12-4.396-2.64 0-4.04 2.294-4.04 4.423 0 2.542 1.485 4.368 4.067 4.368 2.335-.002 4.093-2.046 4.093-4.395zM61.09 25.856c-.273 0-.44-.137-.44-.47v-1.879c0-.332.11-.47.495-.47h2.28v-8.235h-2.417c-.385 0-.495-.138-.495-.47v-1.88c0-.332.165-.47.44-.47h4.59c.412 0 .604.276.604.663v10.392h2.143c.386 0 .495.138.495.47v1.88c0 .332-.164.47-.44.47H61.09zM81.616 17.068c-.082.028-.137-.027-.192-.11-.823-1.934-2.83-2.764-4.78-2.764-1.922 0-2.994.69-2.994 1.851 0 1.381 1.84 1.493 4.175 1.769 2.858.332 5.111 1.215 5.111 3.787 0 2.82-2.554 4.588-5.934 4.588-2.638 0-4.561-.856-5.907-1.851-.11-.11-.164-.193-.164-.333v-3.262c0-.082.027-.165.11-.193l.631-.192c.082-.028.137 0 .192.082.85 2.074 2.967 3.122 5.11 3.122 2.005 0 3.189-.718 3.189-1.906s-1.621-1.381-3.738-1.576c-2.803-.248-5.633-.913-5.633-3.952 0-2.542 2.007-4.506 5.496-4.506 2.776 0 4.698.858 6.074 1.796a.29.29 0 0 1 .136.248v3.04c0 .055-.082.138-.164.165l-.718.197zM94.365 18.119c0-.166.082-.276.358-.276h1.346c.164 0 .303.055.303.276v2.654c0 4.173-2.527 5.416-5.056 5.416-2.694 0-4.671-1.493-4.671-4.836v-6.551h-1.786c-.385 0-.495-.11-.495-.498V13.17c0-.165.055-.276.164-.415l3.49-3.843c.11-.137.192-.193.303-.193h.714c.249 0 .33.138.33.416v2.846h6.101c.249 0 .33.11.33.276v2.239c0 .165-.109.303-.33.303h-6.1v6.136c0 1.713 1.099 2.321 2.417 2.321 1.428 0 2.582-.718 2.582-2.514V18.12zM98.928 25.856c-.274 0-.44-.137-.44-.47v-1.851c0-.333.11-.498.495-.498h2.5v-8.29h-2.5c-.413 0-.495-.138-.495-.47v-1.824c0-.333.164-.47.44-.47h4.176c.468 0 .659.36.659.745v3.73h.247c.273-3.372 1.977-4.505 3.763-4.505.604 0 1.566.082 2.198.69.055.055.082.11.082.22v3.095c0 .11-.054.25-.164.25h-.495c-.082 0-.164-.055-.219-.137-.385-.443-.99-.636-1.731-.664-1.539-.027-3.243 1.354-3.243 4.118v3.51h2.694c.385 0 .494.165.494.498v1.851c0 .332-.164.47-.44.47h-8.02v.002zM124.836 23.84c0 .11-.027.248-.137.332-1.208 1.106-3.215 2.017-5.605 2.017-3.736 0-7.255-2.377-7.255-7.325 0-4.67 3.186-7.242 7.034-7.242 4.066 0 6.401 2.682 6.401 6.247v1.353c0 .22-.164.388-.385.388h-10.14c.219 2.542 2.363 3.702 4.589 3.702 1.813 0 3.626-.745 4.534-2.073.055-.083.137-.083.246-.055l.577.22c.082.055.137.083.137.193v2.243h.004zm-2.169-6.137c0-2.156-1.594-3.316-3.847-3.316-2.527 0-3.82 1.463-4.094 3.316h7.941zM127.53 25.856c-.274 0-.44-.137-.44-.47v-1.879c0-.332.109-.47.494-.47h2.281V9.331h-2.417c-.386 0-.495-.138-.495-.47V6.98c0-.332.164-.47.44-.47h4.561c.413 0 .604.276.604.663v15.863h2.254c.385 0 .495.138.495.47v1.88c0 .332-.165.47-.441.47h-7.336zM143.989 26.189c-5.166 0-7.255-3.427-7.255-7.27 0-3.842 2.089-7.297 7.255-7.297s7.255 3.455 7.255 7.297c0 3.843-2.089 7.27-7.255 7.27zm.027-11.718c-3.215 0-4.616 1.907-4.616 4.45 0 2.515 1.401 4.423 4.616 4.423 3.159 0 4.562-1.906 4.562-4.422 0-2.544-1.401-4.45-4.562-4.45zM26.97 22.97h-3.206c-.74 0-1.044-.221-1.455-.801l-2.847-3.94h.219l.129-.006a5.282 5.282 0 0 0 .77-.077c3.24-.483 4.817-2.91 4.817-5.804 0-3.094-1.704-5.83-6.402-5.83H8.032c-.33 0-.468.137-.468.47V8.97c0 .333.137.47.468.47h2.582v13.487H8.032c-.33 0-.468.138-.468.47v1.99c0 .332.137.47.468.47h7.886c.358 0 .495-.138.495-.47v-1.99c0-.332-.164-.47-.468-.47h-2.417v-5.185c.705.089 1.615.197 2.56.29.01.01.013.021.024.034l4.77 6.952c.33.525.74.883 1.373.883h4.635c.33 0 .55-.138.55-.58v-1.907c-.003-.335-.197-.445-.47-.445z",
    fill: "#F7F7FF"
  }), jsx("path", {
    d: "M13.815 11.438l6.89-2.324-2.312 6.933-1.277-2.366-1.981 1.993-.954-.957 1.984-1.993-2.35-1.286zM64.565 10.781c-.116.117-.255.164-.465.164h-.581c-.163 0-.232-.094-.163-.257l1.767-4.067c.466-1.099 1.14-1.472 1.79-1.472.836 0 1.417.631 1.417 1.38 0 .514-.254 1.052-.928 1.637l-2.837 2.615zM152.098 24.142l-1.335 1.343 1.335 1.344 1.336-1.344-1.336-1.343z",
    fill: "#F73F21"
  }));
};

Logo.defaultProps = {
  height: "37",
  width: "161",
  fill: "none",
  viewBox: "0 0 161 37",
  xmlns: "http://www.w3.org/2000/svg"
};
import { QuestionCircleIcon, ArrowRightBracketsIcon } from '../../icon';
const {
  Navbar,
  NavbarGroup,
  NavbarLink,
  NavbarLogo,
  NavbarDivider
} = TopBar;
const {
  SideMenu,
  MenuDisclosure,
  Menu,
  MenuItem
} = SideMenuComponent;
const {
  AlertResetPasswordModal
} = ModalsComponent;
const Header = /*#__PURE__*/React.memo(({
  user,
  auth,
  headerLogo,
  termsAndConditions,
  usagePolicies,
  options
}) => {
  var _user$digitalRecord$P, _user$digitalRecord, _user$digitalRecord2;

  const history = useHistory();
  const {
    t,
    i18n
  } = useTranslation();
  const {
    roles
  } = user;
  const {
    changeRol,
    logout
  } = auth;
  const {
    isMobile
  } = useMediaQuery();
  const {
    name = '',
    lastname = '',
    secondlastname = ''
  } = (_user$digitalRecord$P = user === null || user === void 0 ? void 0 : (_user$digitalRecord = user.digitalRecord) === null || _user$digitalRecord === void 0 ? void 0 : _user$digitalRecord.PersonalInformation) !== null && _user$digitalRecord$P !== void 0 ? _user$digitalRecord$P : user === null || user === void 0 ? void 0 : (_user$digitalRecord2 = user.digitalRecord) === null || _user$digitalRecord2 === void 0 ? void 0 : _user$digitalRecord2.Organization;

  const doChangeRol = async id => {
    try {
      await changeRol({
        body: {
          id
        }
      });
      history.push('/');
    } catch (error) {
      console.error(error);
    }
  };

  if (!user || !auth) {
    return jsx(React.Fragment, null, jsx("span", null, t('El contexto de usuario y autenticación es requerido!')));
  }

  return jsx(Navbar, {
    css: {
      display: isUIWebView ? 'none' : 'flex !important',
      position: 'sticky',
      top: 0,
      zIndex: 1
    }
  }, jsx(NavbarGroup, {
    align: "left"
  }, jsx(NavbarLogo, null, jsx(NavbarLink, {
    onClick: () => history.push('/')
  }, jsx("img", {
    height: "120px",
    width: "120px",
    src: headerLogo,
    alt: "",
    css: {
      [mediaQuery[0]]: {
        height: 37
      }
    }
  })))), jsx(NavbarGroup, {
    align: "right"
  }, !isMobile && jsx(React.Fragment, null, jsx(NavbarDivider, {
    containerStyle: {
      marginRight: 0
    }
  }), jsx("div", {
    style: {
      width: 'calc(370px + (422 - 370) * ((100vw - 768px) / (1600 - 768)))'
    }
  }, jsx(DropDownRol, {
    roles: roles,
    onChange: doChangeRol,
    name: `${name} ${lastname} ${secondlastname}`
  })), jsx(NavbarDivider, {
    containerStyle: {
      marginLeft: 0,
      marginRight: 0
    }
  }), jsx("div", {
    style: {
      width: 172
    }
  }, jsx(LanguageSelectorNav, {
    i18n: i18n
  })), jsx(NavbarDivider, {
    containerStyle: {
      marginLeft: 0,
      marginRight: 110
    }
  })), jsx(MenuAlt, {
    termsAndConditions: termsAndConditions,
    usagePolicies: usagePolicies,
    logout: logout,
    options: options
  })));
});

const Footer = ({
  footerLogo,
  footerText = 'Tramite ¡YA!. 2020.'
}) => jsx("footer", {
  css: [style, {
    display: isUIWebView ? 'none' : 'flex !important',
    flex: 'unset'
  }]
}, jsx("div", {
  className: "divider"
}), jsx("div", {
  className: "column-left"
}, jsx("p", null, footerText)), jsx("div", {
  className: "column-right",
  style: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    padding: '7px 15px 7px 0'
  }
}, Array.isArray(footerLogo) ? jsx(React.Fragment, null, footerLogo.map((logo, index) => jsx(React.Fragment, {
  key: `${logo}`
}, index > 0 && jsx("div", {
  style: {
    height: '100%',
    borderLeft: '1px solid #A0B9C8',
    marginLeft: 15,
    marginRight: 15
  }
}), jsx("img", {
  src: logo,
  alt: "racsa"
})))) : jsx("img", {
  src: footerLogo,
  alt: "racsa"
})));

const Path = props => jsx(motion.path, _extends({
  fill: "transparent",
  strokeWidth: "1.8",
  stroke: "#fff",
  strokeLinecap: "round"
}, props));

const sidebar = {
  initial: {
    clipPath: 'circle(30px at 97% 3.2%)'
  },
  open: (height = 1000) => ({
    clipPath: `circle(${height * 2 + 200}px at 97% 3.2%)`,
    transition: {
      type: 'spring',
      stiffness: 40,
      restDelta: 2
    }
  }),
  closed: {
    clipPath: 'circle(30px at 97% 3.2%)',
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 40
    }
  }
};

function MenuAlt({
  usagePolicies,
  termsAndConditions,
  logout,
  options
}) {
  const [isOpen, toggleOpen] = useCycle(false, true);
  const {
    pathname
  } = useLocation();
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const [index, setIndex] = React.useState(() => {
    let newIndex = 0;
    const navs = [...options[0], ...options[1], ...options[2]];
    navs.forEach((nav, i) => {
      if (nav.to === pathname) {
        newIndex = i;
      }
    });
    return newIndex;
  });

  function handleOnKeyPress(e) {
    const fields = Array.from(e.currentTarget.querySelectorAll('button')) || [];

    if (e.key === 'ArrowUp') {
      setIndex(current => {
        const newIndex = current === 0 ? 9 : current - 1;
        fields[newIndex].focus();
        return newIndex;
      });
    } else if (e.key === 'ArrowDown') {
      setIndex(current => {
        const newIndex = current === 9 ? 0 : current + 1;
        fields[newIndex].focus();
        return newIndex;
      });
    }
  }

  function handleClick(to) {
    toggleOpen();
    history.push(to);
  }

  const [firstNavOptions, secondNavOptions, thirdNavOptions] = options;
  return jsx(motion.div, {
    initial: "initial",
    animate: isOpen ? 'open' : 'closed',
    css: css`
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100vw;
        box-sizing: border-box;
      `,
    variants: {
      initial: {
        height: '0'
      },
      open: {
        height: '100vh',
        overflow: 'hidden'
      },
      closed: {
        height: '0',
        overflow: 'unset',
        transition: {
          type: 'spring',
          stiffness: 400,
          damping: 40,
          delay: 0.5
        }
      }
    },
    onKeyDown: e => {
      if (e.key === 'Escape') {
        toggleOpen();
      }
    }
  }, jsx(Global, {
    styles: css`
          .sidebar {
            z-index: ${isOpen ? -1 : 1}!important;
          }

          #root {
            overflow: ${isOpen ? 'hidden' : 'unset'};
          }

          .wizard-step-list-item {
            z-index: ${isOpen ? 0 : 1}!important;
            transition: z-index ${isOpen ? '1.13s' : '0s'} !important;
          }
        `
  }), jsx(motion.div, {
    initial: "initial",
    animate: isOpen ? 'open' : 'closed',
    css: css`
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          width: 100vw;
          background-color: #0d1f2d;
          overflow: hidden;
        `,
    variants: sidebar
  }), jsx("button", {
    type: "button",
    onClick: toggleOpen,
    css: css`
          background: #08415c;
          border: none;
          display: flex;
          align-items: center;
          width: 105px;
          height: 35px;
          border-radius: 20px;
          justify-content: center;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 17px;
          letter-spacing: 0.01em;
          color: #f4fbfe;
          cursor: pointer;
          position: absolute;
          right: 15px;
          top: 13px;
          z-index: 1;
        `
  }, t('Menú'), jsx("svg", {
    width: "21",
    height: "13",
    viewBox: "0 0 21 13",
    css: css`
            margin-left: 8px;
          `
  }, jsx(Path, {
    variants: {
      closed: {
        d: 'M 10.5 1.1 L 20 1.1'
      },
      open: {
        d: 'M 20 1 L 1 11.9'
      }
    }
  }), jsx(Path, {
    d: "M 1 6.5 L 20 6.5",
    variants: {
      closed: {
        opacity: 1
      },
      open: {
        opacity: 0
      }
    },
    transition: {
      duration: 0.1
    }
  }), jsx(Path, {
    variants: {
      closed: {
        d: 'M 1 11.9 L 10.5 11.9'
      },
      open: {
        d: 'M 1 1 L 20 11.9'
      }
    }
  }))), jsx(motion.div, {
    css: css`
          /* display: grid; */
          display: none;
          position: absolute;
          width: 100vw;
          height: 100vh;
          box-sizing: border-box;
          grid-template-columns: 30% 1fr 1fr 1fr;
        `,
    variants: {
      closed: {
        display: 'none',
        transition: 0
      },
      open: {
        display: 'grid'
      }
    },
    transition: {
      delay: 0.4
    },
    onKeyDown: handleOnKeyPress
  }, jsx("div", {
    css: css`
            border-right: 1px solid #08415c;
            padding: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          `
  }, jsx(Logo, {
    css: css`
              width: 147px;
              height: 61px;
            `
  }), jsx("ul", {
    css: css`
              margin: 0;
              padding: 0;
              list-style: none;
              gap: 20px;
            `,
    role: "menu"
  }, jsx("li", {
    css: listItemSecondaryStyle,
    role: "menuitem"
  }, jsx("a", {
    href: termsAndConditions,
    target: "_blank",
    rel: "noreferrer"
  }, t('Términos y condiciones - Regístrelo'))), jsx("li", {
    css: listItemSecondaryStyle,
    role: "menuitem"
  }, jsx("a", {
    href: usagePolicies,
    target: "_blank",
    rel: "noreferrer"
  }, t('Condiciones de uso'))), jsx("li", {
    css: [listItemSecondaryStyle, css`
                  a {
                    display: flex;
                    align-items: center;
                    svg {
                      margin-right: 7px;
                    }
                  }
                `],
    role: "menuitem"
  }, jsx("a", {
    href: usagePolicies,
    target: "_blank",
    rel: "noreferrer"
  }, jsx(QuestionCircleIcon, null), " ", t('Ayuda'))))), jsx("div", {
    css: boxStyle
  }, jsx("nav", null, jsx("ul", {
    css: css`
                margin: 0;
                padding: 0;
                list-style: none;
                display: flex;
                flex-direction: column;
              `,
    "aria-label": "Menu",
    role: "menu",
    tabIndex: -1
  }, React.Children.map(firstNavOptions, (child, childIndex) => jsx("li", {
    css: listItemStyle,
    role: "menuitem"
  }, cloneElement(child, {
    key: child.props.to,
    tabIndex: index === childIndex ? 0 : -1,
    onClick: () => handleClick(child.props.to)
  })))))), jsx("div", {
    css: boxStyle
  }, jsx("nav", null, jsx("ul", {
    css: css`
                margin: 0;
                padding: 0;
                list-style: none;
                display: flex;
                flex-direction: column;
              `,
    "aria-label": "Menu",
    role: "menu",
    tabIndex: -1
  }, React.Children.map(secondNavOptions, (child, childIndex) => jsx("li", {
    css: listItemStyle,
    role: "menuitem"
  }, cloneElement(child, {
    key: child.props.to,
    tabIndex: index === firstNavOptions.length + childIndex ? 0 : -1,
    onClick: () => handleClick(child.props.to)
  })))))), jsx("div", {
    css: [boxStyle, css`
              flex-direction: column;
              justify-content: center;
            `]
  }, jsx("nav", null, jsx("ul", {
    css: css`
                margin: 0;
                padding: 0;
                list-style: none;
                display: flex;
                flex-direction: column;
              `
  }, React.Children.map(thirdNavOptions, (child, childIndex) => jsx("li", {
    css: listItemStyle,
    role: "menuitem"
  }, cloneElement(child, {
    key: child.props.to,
    tabIndex: index === secondNavOptions.length + childIndex ? 0 : -1,
    onClick: () => handleClick(child.props.to)
  }))))), jsx("button", {
    type: "button",
    css: css`
              position: absolute;
              bottom: 30px;
              background: transparent;
              border: none;
              font-family: Rubik;
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              line-height: 28px;
              display: flex;
              align-items: center;
              letter-spacing: 3px;
              color: #f93545;
              text-transform: uppercase;
              cursor: pointer;
            `,
    onClick: logout
  }, jsx(ArrowRightBracketsIcon, {
    css: css`
                width: 30px;
                height: 30px;
                color: currentColor;
                margin-right: 21px;
              `
  }), t('Cerrar sesión')))));
}

const boxStyle = css`
  border-right: 2px solid #08415c;
  display: flex;
  align-items: center;
  nav {
    width: 100%;
  }

  :last-child {
    border-right: unset;
    nav {
      margin-top: -142px;
    }
  }
`;
const listItemSecondaryStyle = css`
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 20px;

  a {
    color: #d4e4ed;
  }

  :last-child {
    margin-bottom: 0;
  }
`;
const listItemStyle = css`
  border-bottom: 1px solid #08415c;
  height: 71px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;
export const MenuComp = ({
  useUser,
  useAuth,
  termsAndConditions,
  usagePolicies
}) => {
  const childRef = /*#__PURE__*/React.createRef();
  const {
    t,
    i18n
  } = useTranslation();
  const {
    user
  } = useUser();
  const {
    logout
  } = useAuth();
  const history = useHistory();
  const [navigateToReset, setNavigateToReset] = React.useState(false);
  const {
    isMobile
  } = useMediaQuery();

  const goTo = path => {
    childRef.current.toggleMenu();
    history.push(path);
  };

  const showModalPassword = () => {
    // childRef.current.toggleMenu()
    setNavigateToReset(true);
  };

  return jsx(SideMenu, {
    sideMenuRef: childRef
  }, jsx(AlertResetPasswordModal, {
    isVisible: navigateToReset,
    user: user,
    app: "sso",
    api: "api",
    setNavigateToReset: setNavigateToReset
  }), jsx(MenuDisclosure, {
    style: {
      width: 30,
      height: 30
    }
  }), jsx(Menu, {
    style: isMobile ? {
      minHeight: '100vh',
      height: 'unset'
    } : {}
  }, jsx(MenuItem, {
    className: "big",
    containerStyle: {
      marginBottom: 0,
      lineHeight: '35px'
    }
  }, user.name, " ", user.lastname), jsx(MenuItem, {
    className: "small",
    containerStyle: {
      marginTop: 12,
      marginBottom: 35,
      fontWeight: 'bold'
    }
  }, user.email), isMobile && jsx(LanguageSelectorMobile, {
    i18n: i18n,
    parentRef: childRef
  }), jsx(MenuItem, {
    onClick: () => goTo('/')
  }, t('Inicio')), jsx(MenuItem, {
    onClick: () => goTo('/procedures')
  }, t('Trámites')), jsx(MenuItem, {
    onClick: () => goTo('/profile')
  }, t('Perfil')), jsx(MenuItem, {
    onClick: () => goTo('/?view=documents')
  }, t('Documentos')), jsx(MenuItem, {
    onClick: () => window.open(termsAndConditions, '_blank')
  }, t('Términos y condiciones - Regístrelo')), jsx(MenuItem, {
    onClick: () => window.open(usagePolicies, '_blank')
  }, t('Condiciones de uso')), jsx(MenuItem, {
    onClick: () => showModalPassword()
  }, t('Cambiar contraseña')), jsx(MenuItem, {
    onClick: () => window.open(process.env.REACT_APP_HELP_URL, '_blank'),
    containerStyle: isMobile ? {
      marginBottom: 70
    } : {}
  }, t('Ayuda')), jsx(MenuItem, null, jsx("div", {
    className: "side-menu-footer"
  }, jsx("span", {
    className: "logout",
    onClick: logout,
    role: "button",
    tabIndex: 0,
    style: {
      textTransform: 'uppercase'
    }
  }, t('Cerrar sesión'))))));
};

function Layout({
  children,
  user,
  auth,
  headerLogo,
  footerLogo,
  footerText,
  termsAndConditions,
  usagePolicies,
  navOptions
}) {
  return jsx(React.Fragment, null, jsx(Header, {
    user: user,
    auth: auth,
    headerLogo: headerLogo,
    termsAndConditions: termsAndConditions,
    usagePolicies: usagePolicies,
    options: navOptions
  }), children, jsx(Footer, {
    footerLogo: footerLogo,
    footerText: footerText
  }));
}

export default Layout;